const initialState = {
  codblbr: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "BLBR_COD":
      return {
        ...state,
        codblbr: action.payload,
      };
    default:
      return state;
  }
}
